<template>
  <div class='vertical-field'>
    <div class="field-label">
      Скан копия
    </div>
    <dashboard
      :uppy='uppy'
      :plugins="['ImageEditor']"
      :props='dashboardOptions'
    />
  </div>
</template>

<script>
import Uppy from '@uppy/core'
import { Dashboard } from '@uppy/vue'
import ImageEditor from '@uppy/image-editor'
import XHRUpload from '@uppy/xhr-upload'
import { v4 as uuidv4 } from 'uuid'
import { BaseApiClient } from '@/common/helpers/BaseApiClient'
import RusUppy from '@uppy/locales/lib/ru_RU'
import axios from 'axios'
export default {
  components: { Dashboard },

  props: {
    baseUrl: {
      type: String
    },

    application: {
      type: Object
    }
  },

  data: () => {
    return {
      files: [],
      apiUrl: process.env.VUE_APP_API_URL,
      enableUserSign: process.env.VUE_APP_ENABLE_USER_SIGN,
      dashboardOptions: {
        width: '100%',
        height: 340,
        inline: true,
        showProgressDetails: true,
        doneButtonHandler: null,
        showRemoveButtonAfterComplete: true,
        proudlyDisplayPoweredByUppy: false,
        target: '.DashboardContainer',
        replaceTargetContent: true,
        note: 'Изображения и pdf до 20Мб',
        browserBackButtonClose: false,
        showLinkToFileUploadResult: true
      }
    }
  },

  methods: {
    sendDeleteRequestForFile (file) {
      axios({
        method: 'post',
        url: this.apiUrl + '/upload/remove-app-scan',
        headers: BaseApiClient.getAuthHeaders(),
        data: {
          fileName: file.name,
          applicationNumber: file.meta.applicationNumber
        }
      })
    },

    dataURItoBlob (dataURI, mimeString) {
      const byteString = atob(dataURI)

      // write the bytes of the string to an ArrayBuffer
      const ab = new ArrayBuffer(byteString.length)
      const ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      // write the ArrayBuffer to a blob, and you're done
      return new Blob([ab])
    }
  },

  computed: {
    uppy() {
      return new Uppy(
        {
          width: '100%',
          locale: RusUppy,
          allowMultipleUploads: true,
          autoProceed: true,
          debug: false,
          restrictions: {
            maxFileSize: 1024 * 1024 * 20,
            minFileSize: null,
            maxTotalFileSize: null,
            maxNumberOfFiles: null,
            minNumberOfFiles: 1,
            allowedFileTypes: ['image/*', '.pdf']
          },
          onBeforeFileAdded: (currentFile, files) => {
            if (currentFile.remote !== true) {
              const ext = currentFile.name.split('.').pop()
              const name = uuidv4() + '.' + ext

              return {
                ...currentFile,
                name,
                meta: {
                  ...currentFile.meta,
                  name
                }
              }
            }
          }
        }
      ).use(ImageEditor, {
        trigger: '#dashboard',
        quality: 1,
        actions: {
          revert: true,
          rotate: true,
          flip: true,
          zoomIn: true,
          zoomOut: true,
          cropSquare: false,
          cropWidescreen: false,
          cropWidescreenVertical: false
        },
        locale: {
          strings: {
            save: 'Сохранить',
            revert: 'Вернуть к исходному состоянию',
            rotate: 'Повернуть',
            flipHorizontal: 'Отразить по горизонтали',
            zoomIn: 'Увеличить',
            zoomOut: 'Уменьшить'
          }
        }
      }).use(XHRUpload, {
        limit: 10,
        headers: BaseApiClient.getAuthHeaders(),
        endpoint: this.apiUrl + '/upload/signed-app',
        formData: true,
        fieldName: 'file'
      })
    }
  },

  created () {
    if (this.enableUserSign && this.application.status === 'awaiting_signing') {
      const appNumber = this.application.number
      axios({
        method: 'get',
        url: this.apiUrl + '/get-file/scan-copy-blob?applicationId=' + this.application.id,
        headers: BaseApiClient.getAuthHeaders()
      })
        .then(result => {
          if (Number(result.status) === 200) {
            const files = result.data.data
            files.forEach(file => {
              const id = this.uppy.addFile({
                name: file.name,
                type: file.type,
                data: this.dataURItoBlob(file.data, file.type),
                size: file.size,
                remote: true
              })
              this.uppy.setFileState(id, {
                progress: { uploadComplete: true, uploadStarted: true }
              })
              this.uppy.setFileState(id, {
                uploadURL: this.baseUrl + '/get-file/scan-copy' +
                  '?filename=' + file.name +
                  '&applicationId=' + this.application.id
              })
            }
            )
          }
        })
      this.uppy.on('file-removed', (file, reason) => {
        if (reason === 'removed-by-user') {
          this.sendDeleteRequestForFile(file)
          this.$emit('attach-scan-copy', this.uppy.getFiles())
        }
      })

      this.uppy.on('upload-success', (file, data, uploadUrl) => {
        this.uppy.setFileState(file.id, {
          uploadURL: this.baseUrl + '/get-file/scan-copy' +
            '?filename=' + file.name +
            '&applicationId=' + this.application.id
        })
      })

      this.uppy.on('file-added', (file) => {
        this.uppy.setFileMeta(file.id, {
          applicationNumber: appNumber
        })
        this.$emit('attach-scan-copy', this.uppy.getFiles())
      })
    }
    return null
  }
}
</script>
